/**
 * Created by FDD on 2017/5/22.
 * @desc 常用变量
 */
export const FITTING_COUNT = 100;
export const HALF_PI = Math.PI / 2;
export const ZERO_TOLERANCE = 0.0001;
export const TWO_PI = Math.PI * 2;
export const BASE_LAYERNAME = 'ol-plot-vector-layer'; // 矢量图层名，（唯一标识）
export const BASE_HELP_CONTROL_POINT_ID = 'plot-helper-control-point-div'; // 控制点要素的基类id
export const BASE_HELP_HIDDEN = 'plot-helper-hidden-div'; // 父类隐藏容器
export const DEF_TEXT_STYEL = {
  // 默认文本框样式
  borderRadius: '2px',
  fontSize: '12px',
  outline: 0,
  overflow: 'hidden',
  boxSizing: 'border-box',
  border: '1px solid #eeeeee',
  fontFamily:
    'Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Noto Sans CJK SC,WenQuanYi Micro Hei,Arial,sans-serif',
  color: '#010500',
  fontWeight: 400,
  padding: '3px',
  fontStretch: 'normal',
  lineHeight: 'normal',
  textAlign: 'left',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: 'auto',
  height: 'auto',
  background: 'rgb(255, 255, 255)',
  fontStyle: '',
  fontVariant: '',
};
